import { Pipe, PipeTransform } from '@angular/core';
import { ProductAttributeFormat } from '../interfaces/interfaces';

@Pipe({
    name: 'productattributeformat'
})
export class ProductAttributeformatPipe implements PipeTransform {
    transform(productAttributeFormat: ProductAttributeFormat): string {
        switch (productAttributeFormat) {
            case ProductAttributeFormat.TEXT: return 'Szöveges';
            case ProductAttributeFormat.NUMBER: return 'Szám';
            case ProductAttributeFormat.CHECKBOX: return 'Igaz / Hamis';
        }
        return '';
    }
}
